<template>
  <div>
    <div
      class="content joint-page"
      :class="isH5 ? 'mobile-joint-page' : 'pc-joint-page'"
    >
      <div class="page-content-wrap" :style="[backgroud]">
        <div class="page-content">
          <img
            v-if="jointInfo.head_img"
            class="head-img"
            :src="handleImageUrl(jointInfo.head_img) + '?imageView2/0/w/750'"
            alt=""
          />
          <!-- 课程分组列表 -->
          <div v-if="jointInfo.class_groups && jointInfo.class_groups.length">
            <!-- 全部购买 -->
            <ul v-if="jointInfo.buy_mode === 2" class="course-group-list">
              <li
                v-for="group in jointInfo.class_groups"
                :key="group.id"
                class="group-item"
              >
                <div class="group-name">
                  <p class="name">{{ group.title }}</p>
                </div>
                <div
                  v-if="group.course_list && group.course_list.length"
                  class="course-list all-buy"
                >
                  <div
                    class="course-item-wrap"
                    v-for="course in group.course_list"
                    :key="course.course_id"
                  >
                    <CourseCard :isH5="isH5" :couseInfo="course" />
                  </div>
                </div>
              </li>
            </ul>
            <!-- 其他 -->
            <ul class="course-group-list" v-else>
              <li
                v-for="(group, index) in jointInfo.class_groups"
                :key="group.id"
                class="group-item"
              >
                <div class="group-name">
                  <p class="name">{{ group.title }}</p>
                  <!-- 自由模式+限购 -->
                  <div v-if="jointInfo.is_limited === 1" class="left">
                    <img
                      src="../../assets/images/joint-purchase/tips-icon.png"
                      alt=""
                    />
                    限购一个
                  </div>
                </div>
                <el-checkbox-group
                  :key="group.id"
                  v-model="selectedIds[index]"
                  v-if="group.course_list && group.course_list.length"
                  @change="(value) => handleCheckChange(value, index)"
                  class="course-list"
                >
                  <el-checkbox
                    :disabled="handleCheckBoxDisabled(course.goods_id, index)"
                    @click.native="
                      handleCheckboxClick(course.goods_id, index, true)
                    "
                    v-for="course in group.course_list"
                    :key="course.goods_id"
                    :label="course.goods_id"
                    class="course-item-wrap"
                    :class="{
                      'is-must-buy':
                        jointInfo.mustBuyGoodsId &&
                        jointInfo.mustBuyGoodsId.includes(course.goods_id),
                    }"
                  >
                    <CourseCard :isH5="isH5" :couseInfo="course" />
                  </el-checkbox>
                </el-checkbox-group>
              </li>
            </ul>
          </div>
        </div>
        <!-- 底部 -->
        <div class="fixed-bottom">
          <div class="bottom-cont">
            <!-- 优惠提示 -->
            <p
              v-if="nextDiscountTips"
              class="tips"
              v-html="nextDiscountTips"
            ></p>
            <!-- 价格区域 -->
            <div class="price-wrap">
              <div class="left">
                <span class="total-price"
                  ><i>￥</i>{{ priceInfo.real_price / 100 }}</span
                >
                <!-- 有实付价格 -->
                <div
                  v-if="priceInfo.original_price !== 0"
                  class="discount-info"
                >
                  <p
                    v-if="nowDiscountedTips"
                    class="discount-price"
                    v-html="nowDiscountedTips"
                  ></p>
                  <p
                    v-if="priceInfo.original_price != priceInfo.real_price"
                    class="original-price"
                  >
                    课程原价:￥{{ priceInfo.original_price / 100 }}
                  </p>
                </div>
              </div>
              <button
                @click="buyCourses"
                class="buy-btn"
                :class="{ 'is-disabled': jointInfo.activityStatus !== 2 }"
                :disabled="jointInfo.activityStatus !== 2"
                v-preventReClick
              >
                {{ buyBtnText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="confirm-order-container"></div>
  </div>
</template>

<script>
// 分享
// import wx from "weixin-js-sdk";
import Vue from "vue";
import Confirm from "@saas/components/src/components/confirm-order/index";
Vue.use(Confirm);
import { pageShare, isWeChat, isMqq, isMobile } from "@saas/components";
import CourseCard from "./components/CourseCard";
import { mapGetters } from "vuex";
import {
  getJointInfo,
  calPrice,
} from "@saas/server-api/src/joint-purchase/index";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { isHXApp, handleImageUrl } from "@saas/components/src";
export default {
  data: function () {
    return {
      isH5: document.body.clientWidth < 415,
      checkedCities: [], //多选
      radio: "", //单选
      type: 1,
      jointInfo: {},
      union_id: "",
      priceInfo: {
        real_price: 0,
        original_price: 0,
      },
      selectedIds: [],
      union_pricing: {}, //当前阶梯优惠
      next_union_pricing: {}, //下一个阶梯优惠
      nowDiscountedTips: "", //当前优惠信息：已省...
      nextDiscountTips: "", //下一阶梯提示：再买。。。
      submiting: false,
      isHXApp: isHXApp(),
      handleImageUrl,
      lastLadderId: "",
    };
  },
  mounted() {
    this.union_id = Number(this.$route.params.union_id);
    // 获取详情
    this.apiGetJointInfo();
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        if (isLogin) {
          // 重新获取页面信息
          this.apiGetJointInfo();
        }
      });
    }
    // this.inintWechatShare();
  },
  computed: {
    // 扁平化已选择课程ids
    flatSelectedIds() {
      let arr = [];
      this.selectedIds.forEach((item) => {
        arr = arr.concat(item);
      });
      return arr;
    },
    handleCheckBoxDisabled() {
      return (goods_id, index) => this.handleCheckboxClick(goods_id, index);
    },
    // 购买按钮文本
    buyBtnText() {
      let str = "马上抢购";
      if (this.jointInfo?.activityStatus === 1) {
        str = "活动未开始";
      } else if (this.jointInfo?.activityStatus === 3) {
        str = "活动已结束";
      } else {
        // 进行中
        if (!this.isAuthenticated) {
          str = "登录后选课";
        }
      }
      return str;
    },
    backgroud() {
      return {
        background: this.jointInfo.union_bg_color || "",
      };
    },
    isMobile() {
      return isMobile();
    },
    isWechat() {
      return isWeChat();
    },
    isMqq() {
      return isMqq();
    },
    ...mapGetters(["isAuthenticated", "user"]),
  },
  components: {
    CourseCard,
  },
  methods: {
    // 课程点击事件
    handleCheckboxClick(goods_id, index, showToast = false) {
      if (
        this.jointInfo.mustBuyGoodsId &&
        this.jointInfo.mustBuyGoodsId.includes(goods_id)
      ) {
        if (showToast) {
          this.$message.warning(`必购课程`);
        }
        return true;
      }
      // 没有最大购买限制
      if (!this.jointInfo?.max_buy_num) {
        return false;
      }
      // 有最大购买限制
      let status = false;
      let selectedNum = this.flatSelectedIds.length;
      if (
        !(selectedNum < this.jointInfo.max_buy_num) &&
        !this.selectedIds[index].includes(goods_id)
      ) {
        status = true;
      }
      // 限购一个时
      if (this.jointInfo.is_limited === 1 && this.selectedIds[index]?.length) {
        status = false;
      }
      if (status && showToast) {
        this.$message.warning(
          `活动限制最多选择${this.jointInfo.max_buy_num}门课程`
        );
      }
      return status;
    },
    // 组内课程选择改变
    handleCheckChange(value, index) {
      // 单选：自由+限购
      if (this.jointInfo.buy_mode === 1 && this.jointInfo.is_limited === 1) {
        if (this.selectedIds[index].length > 1) {
          this.$set(this.selectedIds, index, this.selectedIds[index].slice(-1));
        }
      }
      // 计算价格
      this.apiCalPrice();
    },
    apiGetJointInfo() {
      let union_id = this.$route.params.union_id;
      if (!union_id) return;
      let params = {
        union_id,
      };
      getJointInfo(params).then((res) => {
        if (res.code === 1) {
          let data = res.data || {};
          let { begin_at, end_at } = data;
          // 处理活动状态：1：未开始，2：进行中，3：已结束
          let now = new Date().getTime();
          if (now < begin_at * 1000) {
            data.activityStatus = 1;
          } else if (now > end_at * 1000) {
            data.activityStatus = 3;
          } else {
            data.activityStatus = 2;
          }
          if (data.activityStatus !== 2) {
            this.$chiralConfirmMessage(
              `活动${data.activityStatus === 1 ? "未开始" : "已结束"}`
            );
          }
          // 全部购买
          if (data.class_groups?.length) {
            for (let index = 0; index < data.class_groups.length; index++) {
              this.selectedIds[index] = [];
            }
            if (data.buy_mode === 2) {
              data.class_groups.forEach((group, index) => {
                group.course_list.forEach((course) => {
                  this.$set(
                    this.selectedIds,
                    index,
                    this.selectedIds[index].concat(course.goods_id)
                  );
                });
              });
            } else if (data.buy_mode === 3) {
              data.mustBuyGoodsId = [];
              data.class_groups.forEach((group, index) => {
                group.course_list.forEach((course) => {
                  if (course.must_buy === 1) {
                    this.$set(
                      this.selectedIds,
                      index,
                      this.selectedIds[index].concat(course.goods_id)
                    );
                    data.mustBuyGoodsId.push(course.goods_id);
                  }
                });
              });
            } else {
              // 默认选中第一个分组的第一个课程
              if (data.class_groups[0]?.course_list?.length) {
                let firstId = data.class_groups[0].course_list[0].goods_id;
                this.selectedIds[0] = [firstId];
              }
            }
          }
          // 初次计算当前价格
          this.apiCalPrice(params);
          this.jointInfo = data;
          // 标题
          let title = data.share_title || data.title || "";
          document.title = title;
          jsToFlutter("setTitle", { title });
          // 最后一档优惠阶梯id
          if (data.ladder_pricing && data.ladder_pricing.length) {
            this.lastLadderId = data.ladder_pricing.splice(-1)[0]?.id;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiCalPrice(type) {
      let compute = true;
      if (type === "buy") {
        compute = false;
      }
      let params = {
        compute,
        union_id: this.union_id,
      };
      params.goods_items = this.flatSelectedIds.map((item) => {
        return {
          goods_id: item,
          activity_type: 3,
          activity_id: this.union_id,
        };
      });
      calPrice(params).then((res) => {
        if (res.code === 1) {
          let data = res.data || {};
          let {
            original_price,
            real_price,
            union_pricing,
            next_union_pricing,
          } = data;
          this.priceInfo = {
            original_price,
            real_price,
          };
          if (type === "buy") {
            let goodsIds = this.flatSelectedIds;
            let calPriceData = res.data;
            calPriceData.activity_type = 3;
            calPriceData.goods_items = params.goods_items;
            let user = this.user;
            document.querySelector(".joint-page").style.display = "none";
            this.$saasConfirmOrder(
              goodsIds,
              "confirm-order-container",
              calPriceData,
              user
            );
          } else {
            this.union_pricing = union_pricing || {};
            this.next_union_pricing = next_union_pricing || {};
            // 底部优惠信息处理
            // 当前阶梯
            let nowDiscountVal = this.union_pricing?.discount_val;
            let nowDiscountType = this.union_pricing?.discount_type;
            let nowDiscountId = this.union_pricing?.id;
            if (nowDiscountType === 2) {
              this.nowDiscountedTips = nowDiscountVal
                ? `已省${nowDiscountVal / 100}元`
                : "";
            } else if (nowDiscountType === 1) {
              let nowDiscountVal = this.union_pricing?.discount_val;
              this.nowDiscountedTips = nowDiscountVal
                ? `已打${nowDiscountVal / 10}折`
                : "";
            } else {
              this.nowDiscountedTips = "";
            }
            // 下一阶梯
            let { discount_type, discount_val, discount_key } =
              this.next_union_pricing;
            if (discount_type === 2) {
              this.nextDiscountTips = `再加 <span>${
                (discount_key - this.priceInfo.original_price) / 100
              } 元</span> 元立减 <span>${discount_val / 100} 元</span>`;
            } else if (discount_type === 1) {
              this.nextDiscountTips = `再选 <span>${
                discount_key - this.flatSelectedIds.length
              } 门</span> 立打 <span>${discount_val / 10} 折</span>`;
            } else if (nowDiscountId && this.lastLadderId === nowDiscountId) {
              this.nextDiscountTips = `<span>已享受活动的最高优惠，超划算</span>`;
            } else {
              this.nextDiscountTips = "";
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // inintWechatShare() {
    //   if (this.isMobile) {
    //     if (this.isWechat || this.isMqq) {
    //       let title = "默认活动名称";
    //       let desc = "";
    //       let pic = "";
    //       const link = window.location.href;
    //       pageShare(wx, { title, desc, link, pic });
    //     }
    //   }
    // },
    buyCourses() {
      if (this.isAuthenticated) {
        if (!this.flatSelectedIds.length) {
          this.$message.warning("请先选择需要购买的课程~");
          return false;
        } else if (this.flatSelectedIds.length < this.jointInfo.min_buy_num) {
          this.$message.warning(
            `活动限制最少选择${this.jointInfo.min_buy_num}门课程`
          );
          return false;
        }
        this.apiCalPrice("buy");
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
      } else {
        // let preRoute = window.location.href;
        // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
        this.$loginDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  max-width: 100%;
  width: 100%;
}
// pc
.pc-joint-page {
  background: #fff;
  .page-content-wrap {
    max-width: 375px;
    margin: 0 auto;
    padding: 0 0 115px;
    min-height: 100vh;
    .head-img {
      width: 100%;
      aspect-ratio: auto 16 / 9;
      max-height: 211px;
      object-fit: cover;
    }
  }
  .course-group-list {
    padding: 13px 16px 10px;
  }
  .group-item {
    padding: 16px 10px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    .group-name {
      display: flex;
      justify-content: space-between;
      margin: 0 6px 16px;
      .name {
        font-size: 14px;
        color: #333333;
        line-height: 13px;
      }
      .left {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 13px;
          margin-right: 8px;
        }
        font-size: 12px;
        color: $activity-color;
        line-height: 17px;
      }
    }
    .all-buy.course-list {
      padding: 0 6px;
    }
    .course-list {
      width: 100%;
      .course-item-wrap:last-child {
        margin-bottom: 0;
      }
      .course-item-wrap {
        display: flex;
        align-items: center;
        margin-right: 0;
        margin-bottom: 16px;
        cursor: pointer;
        .cover {
          width: 120px;
          height: 66px;
          object-fit: cover;
          border-radius: 4px;
          margin-right: 10px;
        }
        .item-right {
          flex: 1;
          width: 0;
          height: 66px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }
          .course-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .lesson-num {
              font-size: 10px;
              color: #222222;
              line-height: 12px;
            }
            .price {
              i {
                font-style: normal;
                font-size: 12px;
              }
              font-size: 18px;
              color: $activity-color;
            }
          }
        }
      }
    }

    // 多选样式
    ::v-deep .el-checkbox__input .el-checkbox__label {
      padding-left: 8px;
    }
    ::v-deep .el-checkbox__input .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }
  }
  // 底部
  .fixed-bottom {
    position: fixed;
    z-index: 9;
    bottom: 0;
    width: 375px;
    max-width: 100%;
    padding-bottom: 34px;
    background: #fff;
    ::v-deep .tips {
      text-align: center;
      width: 100%;
      height: 19px;
      background: rgba($activity-color, 0.1);
      color: #333333;
      line-height: 19px;
      span {
        font-size: 12px;
        color: $activity-color;
      }
    }
    .price-wrap {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      min-width: 345px;
      width: max-content;
      max-width: 100%;
      .left {
        display: flex;
        align-items: center;
        .total-price {
          i {
            font-size: 12px;
            font-style: normal;
          }
          font-weight: 600;
          font-size: 28px;
          color: $activity-color;
          margin-right: 8px;
        }
        .discount-info {
          display: flex;
          flex-direction: column;
        }
        .discount-price {
          width: max-content;
          font-size: 12px;
          color: $activity-color;
          line-height: 17px;
          padding: 0 5px 0 7px;
          margin-bottom: 4px;
          background: url("../../assets/images/joint-purchase/discount-bg.png")
            no-repeat center;
          background-size: 100% 100%;
        }
        .original-price {
          font-size: 12px;
          color: #999999;
          line-height: 17px;
          white-space: nowrap;
        }
      }
    }
    .buy-btn {
      height: 39px;
      min-width: 96px;
      background: $activity-color;
      box-shadow: 0px 4px 8px 0px rgba(255, 74, 4, 0.2);
      border-radius: 20px;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
      line-height: 39px;
      padding: 0 10px;
      text-align: center;
    }
  }
}

// 移动
.mobile-joint-page {
  .page-content-wrap {
    min-height: 100vh;
    padding: 0 0 3.07rem;
    .head-img {
      width: 100%;
      aspect-ratio: auto 16 / 9;
      height: 5.63rem;
      object-fit: cover;
    }
  }
  .course-group-list {
    padding: 0.35rem 0.43rem 0.27rem;
  }
  .group-item {
    padding: 0.43rem 0.27rem;
    background: #ffffff;
    border-radius: 0.21rem;
    margin-bottom: 0.27rem;
    .group-name {
      display: flex;
      justify-content: space-between;
      margin: 0 0.16rem 0.43rem;
      .name {
        font-size: 0.37rem;
        color: #333333;
        line-height: 0.53rem;
      }
      .left {
        display: flex;
        align-items: center;
        img {
          width: 0.37rem;
          height: 0.35rem;
          margin-right: 0.21rem;
        }
        font-size: 0.32rem;
        color: $activity-color;
        line-height: 0.45rem;
      }
    }
    .all-buy.course-list {
      padding: 0 0.16rem;
    }
    .course-list {
      width: 100%;
      .course-item-wrap:last-child {
        margin-bottom: 0;
      }
      .course-item-wrap {
        display: flex;
        align-items: center;
        margin-right: 0;
        margin-bottom: 0.43rem;
        // 解决h5按钮点击后出现黑色背景闪烁
        -webkit-tap-highlight-color: transparent;
        .cover {
          width: 3.2rem;
          height: 1.76rem;
          object-fit: cover;
          border-radius: 4px;
          margin-right: 0.27rem;
        }
        .item-right {
          flex: 1;
          width: 0;
          height: 1.76rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 0.37rem;
            color: #222222;
            line-height: 0.53rem;
          }
          .course-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .lesson-num {
              font-size: 0.27rem;
              color: #222222;
              line-height: 0.32rem;
            }
            .price {
              i {
                font-style: normal;
                font-size: 0.32rem;
              }
              font-size: 0.48rem;
              color: $activity-color;
            }
          }
        }

        // 多选样式
        ::v-deep .el-checkbox__input .el-checkbox__label {
          padding-left: 0.21rem;
        }
        ::v-deep .el-checkbox__input .el-checkbox__inner {
          width: 0.43rem;
          height: 0.43rem;
        }
      }
    }
  }
  // 底部
  .fixed-bottom {
    position: fixed;
    z-index: 9;
    bottom: 0;
    min-width: 100%;
    padding-bottom: 0.91rem;
    background: #fff;
    ::v-deep .tips {
      text-align: center;
      width: 100%;
      height: 0.51rem;
      background: rgba($activity-color, 0.1);
      color: #333333;
      line-height: 0.51rem;
      span {
        font-size: 0.32rem;
        color: $activity-color;
      }
    }
    .price-wrap {
      height: 1.6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      min-width: 9.2rem;
      width: max-content;
      max-width: 100%;
      .left {
        display: flex;
        align-items: center;
        .total-price {
          i {
            font-size: 0.32rem;
            font-style: normal;
          }
          font-weight: 600;
          font-size: 0.75rem;
          color: $activity-color;
          margin-right: 0.21rem;
        }
        .discount-info {
          display: flex;
          flex-direction: column;
        }
        .discount-price {
          width: max-content;
          font-size: 0.32rem;
          color: $activity-color;
          line-height: 0.45rem;
          padding: 0 0.13rem 0 0.19rem;
          margin-bottom: 0.11rem;
          background: url("../../assets/images/joint-purchase/discount-bg.png")
            no-repeat center;
          background-size: 100% 100%;
        }
        .original-price {
          font-size: 0.32rem;
          color: #999999;
          line-height: 0.45rem;
          white-space: nowrap;
        }
      }
    }
    .buy-btn {
      height: 1.04rem;
      min-width: 2.56rem;
      background: $activity-color;
      box-shadow: 0rem 0.11rem 0.21rem 0rem rgba(255, 74, 4, 0.2);
      border-radius: 0.53rem;
      font-weight: 500;
      font-size: 0.4rem;
      color: #ffffff;
      line-height: 1.04rem;
      padding: 0 0.27rem;
      text-align: center;
    }
  }
}
// button 禁用样式
.buy-btn.is-disabled:disabled {
  cursor: not-allowed; /* 更改鼠标指针为禁止符号 */
  opacity: 0.5; /* 降低不透明度以给予视觉提示 */
  pointer-events: none; /* 阻止点击事件 */
}
::v-deep .is-must-buy .el-checkbox__inner {
  opacity: 0.5;
}

// 复选框样式
::v-deep .el-checkbox__label {
  flex: 1;
  display: flex;
}
::v-deep .el-checkbox__input .el-checkbox__inner {
  border-radius: 50%;
  background-color: #fff !important;
}
::v-deep .el-checkbox__inner:hover {
  border-color: #dcdfe6 !important;
}
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #dcdfe6 !important;
}
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
  cursor: pointer !important;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  cursor: pointer !important;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
  display: none;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border: none;
  // 这里用形状为勾选框的图片直接替换
  background: url("../../assets/images/joint-purchase/checked-img.png");
  background-size: 100% 100%;
}
</style>
